import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

import 'zone.js/dist/zone';
import { Utils } from './app/common';

if (environment.production) {
  enableProdMode();
}

// Sentry 초기화
Sentry.init({
  dsn: environment.sentryDSN,
  environment: environment.env,
  tracesSampleRate: 1.0,
  maxBreadcrumbs: 30,
  normalizeDepth: 10,
  sendDefaultPii: true,

  // 어떤 에러 메시지 무시할지 정의
  ignoreErrors: [
    // 브라우저/확장프로그램 관련
    'ResizeObserver loop',
    'Script error',
    'Chrome extension',
    'Safari extension',
    /^chrome-extension:\/\//,
    /^safari-extension:/,
    /^moz-extension:/,
    // 일반적인 무시 패턴
    'Network request failed',
    'Load failed',
    /^UnhandledRejection/,
    // 잘못된 접근
    'Cannot read property',
    'null is not an object',
    'undefined is not an object',
    'Handled unknown error',
  ],

  // 허용할 URL 패턴 (우리 도메인만)
  allowUrls: [environment.apiBaseUrl, window.location.origin],

  beforeSend(event) {
    // 프로덕션 환경에서 동작하도록
    if (environment.env === 'dev') {
      return null;
    }

    // HttpErrorResponse인 경우 그대로 리턴
    const values = event?.exception?.values;
    const firstType = values && values[0] && values[0].type;
    if (firstType && String(firstType).includes('HttpErrorResponse')) {
      return event; // HttpErrorResponse는 레벨 유지
    }

    event.level = 'info';
    return event;
  },
});

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
